import { useGetShouldShowPatientAVS } from './useGetShouldShowPatientAVS';
import { useGetShouldShowReflectionTopics } from './useGetShouldShowReflectionTopics';

export function useReflectionDrawerVisibility() {
  const { shouldShowReflectionTopics } = useGetShouldShowReflectionTopics();
  const { shouldShowPatientAVS } = useGetShouldShowPatientAVS();

  return {
    shouldShow: shouldShowReflectionTopics || shouldShowPatientAVS,
    shouldShowPatientAVS,
  };
}
